import React, { useState } from "react";
import { Box, useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";

//Custom Components and functions
import { validateEmail } from "../../../utils/validations";
import Loader from "../../../utils/Loader";

//css
import "./PasswordLogin.css"

//icons
import png from '../../../icons/background.png';
import Logo from "./icons/Logo.png";
import EmailIcon from "./icons/EmailIcon.png";
import KeyIcon from "./icons/KeyIcon.png";
import { FcGoogle } from "react-icons/fc";
import { RxEyeClosed } from "react-icons/rx";
import { FaRegEye } from "react-icons/fa";
import { callApi } from "../../../utils/utils";
import HelmetWrapper from "../../../utils/HelmetWrapper";

const Login = (props) => {
    const toast = useToast();
    const navigate = useNavigate();

    const { setMfaStatus, setUserEmail } = props || {};

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [viewPassword, setViewPassword] = useState(false);

    const handleEmailInputChange = (e) => {
        setEmail(e.target.value);
    }

    const handleToast = (title, type) => {
        toast({
            title,
            status: type,
            duration: 5000,
            isClosable: true
        });
    };

    const checkMfa = async () => {
        if (!validateEmail(email)) {
            handleToast("Please enter valid email", 'error');
            return;
        }

        if (password == "" || !password) {
            handleToast("Please fill password to continue", 'error');
            return;
        }

        try {
            setIsLoading(true);

            const data = await callApi("POST", `/api/customers/checkMfa`, JSON.stringify({ email, accountDetails: password }));
            const { status = false, message, mfaStatus } = data;

            if (status) {
                setMfaStatus(mfaStatus);
                setUserEmail(email);
                setIsLoading(false);
            } else {
                throw new Error(message);
            }

            if (mfaStatus) {
                handleToast("Password Verified!, Verify 2FA to move forward", 'success');
            } else {
                handleToast("Password Verified!, Setup and verify 2FA to move forward", 'success');
            }
        } catch (e) {
            handleToast(e?.message || "Something went wrong", 'error');
            setIsLoading(false);
        }
    }

    const handlePaste = (e) => {
        e.preventDefault();
        handleToast("Pasting password is not allowed", "error");
    }

    const handleChangePassword = (e) => {
        setPassword(e.target.value);
    }

    const signInUsingGoogle = useGoogleLogin({
        onSuccess: async (response) => {
            try {
                setIsLoading(true);
                const data = await callApi("POST", `/api/customers/singleSignOn`, JSON.stringify({ token: response?.access_token }));
                const { status = false, message, mfaStatus, email } = data;

                if (status) {
                    setMfaStatus(mfaStatus);
                    setUserEmail(email);
                    setIsLoading(false);
                } else {
                    throw new Error(message);
                }

                if (mfaStatus) {
                    handleToast("Verify 2FA to move forward", 'success');
                } else {
                    handleToast("Setup and verify 2FA to move forward", 'success');
                }
            } catch (e) {
                handleToast(e?.message || "Something went wrong", 'error');
                setIsLoading(false);
            }
        },
        onError: (error) => {
            handleToast(error.message, 'error');
        },
    });

    return (
        <>
        <HelmetWrapper title="Transfi Login" description="Transfi Dashboard Login Page"/>
        {isLoading ? <Loader /> :
            <Box className="pa-login-container" backgroundImage={png}>
                <div className="pa-login-card">
                    <img className="pa-login-logo" src={Logo} style={{marginTop: '66px'}}/>
                    <h1 className="pa-login-heading">Welcome to TransFi!</h1>
                    <p className="pa-login-sub-heading">Login to unlock the full experience.</p>
                    <p className="pa-login-email-heading">Email</p>
                    <div style={{ textAlign: 'center' }}>
                        <div className="pa-input-box-div">
                            <span style={{ position: 'absolute' }}>
                                <img src={EmailIcon} className="pa-email-icon" />
                            </span>
                            <input
                                type="email"
                                className="pa-input-email"
                                placeholder="Enter your email address"
                                onChange={(e) => handleEmailInputChange(e)}
                                value={email}
                            />
                        </div>
                    </div>
                    <p className="pa-login-password-heading">Password</p>
                    <div style={{ textAlign: 'center' }}>
                        <div className="pa-input-box-div">
                            <span style={{ position: 'absolute' }}>
                                <img src={KeyIcon} className="pa-key-icon" />
                            </span>
                            <input
                                type={viewPassword ? "text" : "password"}
                                className="pa-input-password"
                                placeholder="Enter your password"
                                value={password}
                                onPaste={(e) => handlePaste(e)}
                                onChange={(e) => handleChangePassword(e)}
                            />
                            {!viewPassword ? <span style={{ position: 'absolute', marginLeft: '-40px', fontSize: '20px', marginTop: '15px' }}>
                                <RxEyeClosed onClick={() => { setViewPassword(true) }} />
                            </span> :
                                <span style={{ position: 'absolute', marginLeft: '-40px', fontSize: '20px', marginTop: '18px' }}>
                                    <FaRegEye onClick={() => { setViewPassword(false) }} />
                                </span>}
                        </div>
                    </div>
                    <button className="pa-button" onClick={() => checkMfa()}>
                        Continue
                    </button>
                    <p className="pa-forget-password-enabled" onClick={() => navigate('/account/login-pwd/reset')}>Forgot Password?</p>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '32px' }}>
                        <div className="pa-horizontal-line"></div>
                        <span className="pa-horizontal-line-text">OR</span>
                        <div className="pa-horizontal-line"></div>
                    </div>
                    <button className="pa-sign-in-with-google-button" onClick={() => signInUsingGoogle()}>
                        <FcGoogle style={{ width: '22px', height: '22px' }} />
                        Sign in with Google
                    </button>
                    <div className="pa-transfi-banner">
                        <p className="pa-powered-by">Powered by</p>
                        <img style={{ width: '24px', height: '17px', marginLeft: '8px', marginRight: '8px' }} src={Logo} />
                        <p className="pa-powered-transfi">TransFi</p>
                    </div>
                </div>
            </Box>}
            </>
    );
};

export default Login;
